export default __webpack_public_path__ + "static/attributes_5-2550a017b390de53cdb1b11acd82ea6a.png";